import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Paper, Tab, Tabs, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import FormularioApp from "app/Core/Components/Formulario/FormularioApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import EmpresaTarefaApp from "app/ERP/EmpresaTarefa/EmpresaTarefaApp";
import FuncionalidadeTagApp from "app/ERP/FuncionalidadeTag/FuncionalidadeTagApp";
import * as AppActions from "app/store/actions";
import TarefaApontamentoApp from "app/Workflow/TarefaApontamento/TarefaApontamentoApp";
import Constante from "Constante.json";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GerenciadorProcessoApp from "../../GerenciadorProcesso/GerenciadorProcessoApp";
import * as Actions from "../Store/Actions/MinhasTarefasActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    paper: {
        border: "1px solid " + theme.palette.divider,
        //marginBottom: "24px",
        padding: "4px"
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "140px",
    }
});

const newTarefaState = {
    idtarefa: null,
    titulo: null,
    tipo: null,
    requeridos: null,
    descricao: null,
    apontamento: null,
    observacao: null,
    idfluxo: null,
    fluxo: "{}",
    formulario: {},
    pessoaformulario: {}
};

const state = {
    form: { ...newTarefaState },
    tagMenuEl: null,
    tabValueStatus: 0,
    tabValue: 0
};

class MinhasTarefasDialog extends XAPPComponent {

    state = { ...state };

    componentDidMount() {
        if (this.props.open !== null) {
            var obj = this.props.open;
            if (this.props.open.idtarefa !== undefined && this.props.open.idtarefa !== null) {
                if (this.props.data && this.props.data !== null) {
                    obj.formulario = this.props.data;
                }
                obj.idformulario = obj.jsonpasso.formulario;
                this.setState({ form: obj });
            }
            else {
                obj.conclusao = null;
                obj.concluido = null;
                obj.requeridos = null;
                obj.solicitante = null;
                obj.responsavel = null;
                if (this.props.data && this.props.data !== null) {
                    obj.formulario = this.props.data;
                    obj.responsavel = this.props.data.responsavel;
                }
                obj.idformulario = obj.jsonpasso.formulario;
                this.setState({ form: obj });
            }
        }
        else {

            this.setState({ form: newTarefaState });
        }
    }

    handleChange = (event) => {
        const form = _.set({ ...this.state.form }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value);
        this.setState({ form });
    };

    onClose = () => {
        this.props.openDialog(null);
        this.props.listFilter();
    };

    handleChangeTabStatus = (ev, value) => {
        this.setState({ tabValueStatus: value });
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue });
    };

    handleFormulario = (_AValue) => {
        this.setState({ form: _.set({ ...this.state.form }, "formulario", _AValue) });
    };

    setRequeridos = (_ARequeridos) => {
        this.setState({ form: { ...this.state.form, "requeridos": _ARequeridos } });
    };

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state.form;

        if (formulario === null || Object.keys(formulario).length < 1 || requeridos === undefined || requeridos === null || Object.keys(requeridos).length < 1) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    };

    getNextStep = (_AID) => {
        const { getTarefa, xappRouteParams, parametros } = this.props;
        this.onClose();
        getTarefa(_AID, xappRouteParams, parametros);
    };

    getMensagemConfirmacao = () => {
        const { user, xappRouteParams } = this.props;
        const { form } = this.state;
        var ASaudacao = "";
        var DataAtual = new Date();
        if (DataAtual.getHours() < 12) {
            ASaudacao = "bom dia";
        }
        else if (DataAtual.getHours() < 18) {
            ASaudacao = "boa tarde";
        }
        else if (DataAtual.getHours() < 23) {
            ASaudacao = "boa noite";
        }
        return Helpers.ReplaceAll(Helpers.ReplaceAll(Helpers.ReplaceAll(Helpers.ReplaceAll(Helpers.ReplaceAll(Constante.mensagem_confirmacao_agendamento
            , "<##SAUDACAO##>", ASaudacao)
            , "<##FUNCIONARIO##>", !_.isNull(user.nomesocial) && user.nomesocial.length > 0 ? user.nomesocial : user.nome)
            , "<##EMPRESA##>", !_.isNull(user.settings.sistemas[xappRouteParams.empresa].nomesocial) && user.settings.sistemas[xappRouteParams.empresa].nomesocial.length > 0 ? user.settings.sistemas[xappRouteParams.empresa].nomesocial : user.settings.sistemas[xappRouteParams.empresa].nome)
            , "<##DATA##>", Helpers.StringDateUSToBR(form.formulario.data))
            , "<##HORA##>", (!_.isUndefined(form.formulario.horario) ? form.formulario.horario.substr(0, 5) : ""));
    };

    getUrlConfirmacaoWhatsApp = (_AFormulario) => {
        var AResponse = "https://api.whatsapp.com/send?phone=";
        if (!_.isUndefined(_AFormulario.whatsapp) && !_.isNull(_AFormulario.whatsapp) && _AFormulario.whatsapp.length > 0) {
            AResponse += _AFormulario.whatsapp;
        }
        else {
            AResponse += _AFormulario.celular;
        }
        AResponse += "&text=" + this.getMensagemConfirmacao();
        return AResponse;
    };

    render() {
        const { xappRouteParams, TagsTarefa, classes, open, readOnly, parametros } = this.props;
        const { form, tabValue, tabValueStatus } = this.state;
        return (
            <XAPPDialog
                id="MinhasTarefas"
                onClose={this.onClose}
                open={open !== null}
                fullWidth
                fullScreen
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {open.jsonpasso && open.jsonpasso.titulo}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.onClose}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{ root: "p-0" }}>

                    {form.idtarefa &&
                        <Tabs
                            value={form.tabValue}
                            onChange={this.handleChangeTab}
                            indicatorColor="secondary"
                            textColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                            classes={{
                                root: "h-32 w-full"
                            }}
                        >
                            <Tab value={0} classes={{ root: "h-32" }} label="Detalhes" />
                            <Tab value={1} classes={{ root: "h-32" }} label="Histórico" />
                        </Tabs>
                    }
                    {tabValue === 0 && open.jsonpasso && (
                        <React.Fragment>
                            {!_.isUndefined(form.pessoaformulario) && !_.isNull(form.pessoaformulario) && form.passofluxo !== 999 && _.isNull(form.conclusao) &&
                                <div className="flex w-full">
                                    <div className="flex-1" />
                                    {!_.isUndefined(form.formulario.data) && !_.isNull(form.formulario.data) && (
                                        ((!_.isUndefined(form.pessoaformulario.whatsapp) && !_.isNull(form.pessoaformulario.whatsapp) && form.pessoaformulario.whatsapp.length > 0) ||
                                            (!_.isUndefined(form.pessoaformulario.celular) && !_.isNull(form.pessoaformulario.celular) && form.pessoaformulario.celular.length > 0))) &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium"
                                            href={this.getUrlConfirmacaoWhatsApp(form.pessoaformulario)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <XAPPButton
                                                key={"Button_EnviarWhatsApp"}
                                                type="Button"
                                                className={"bg-green hover:bg-green text-white mr-8"}
                                                variant="contained"
                                                color="primary"
                                                onClick={(ev) => { }}
                                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                                icon={"whatsapp"}
                                                label={md.mobile() === null && md.tablet() === null ? "Enviar mensagem" : ""}
                                            />
                                        </a>
                                    }
                                    {!_.isUndefined(form.formulario.data) && !_.isNull(form.formulario.data) &&
                                        !_.isUndefined(form.pessoaformulario.email) && !_.isNull(form.pessoaformulario.email) && form.pessoaformulario.email.length > 0 &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium"
                                            href={"mailto:" + form.pessoaformulario.email + "?subject=Mensagem de confirmação&body=" + this.getMensagemConfirmacao()}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <XAPPButton
                                                key={"Button_EnviarEmail"}
                                                type="Button"
                                                className={"bg-orange hover:bg-orange text-white"}
                                                variant="contained"
                                                color="primary"
                                                onClick={(ev) => { }}
                                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                                icon={"email"}
                                                label={md.mobile() === null && md.tablet() === null ? "Enviar email" : ""}
                                            />
                                        </a>
                                    }
                                </div>
                            }
                            <div className="p-16 sm:p-24">
                                <FormularioApp
                                    Formulario={JSON.parse(open.jsonpasso.formulario)}
                                    onChange={this.handleFormulario}
                                    data={{ ...form.formulario, ...form.pessoaformulario }}
                                    setRequeridos={this.setRequeridos}
                                    readOnly={readOnly || form.conclusao !== null}
                                    idfluxo={form.idfluxo}
                                    responsavel={form.responsavel}
                                    fluxo={form.fluxo}
                                    xappRouteParams={xappRouteParams}
                                    pessoaformulario={form.pessoaformulario}
                                />
                            </div>
                        </React.Fragment>
                    )}

                    {/*form.idtarefa && tabValue === 1 && (
                        <div>
                            <TarefaHistoricoApp
                                xappRouteParams={xappRouteParams}
                                idtarefaprocesso={form.idtarefaprocesso}
                            />
                        </div>
                    )*/}

                    {form.idtarefa && tabValue === 2 && !_.isNull(form.apontamento) && form.apontamento.length > 0 && (
                        <div>
                            <TarefaApontamentoApp
                                xappRouteParams={xappRouteParams}
                                foreingKey={form.idtarefaprocesso}
                                apontamento={form.apontamento}
                                idpessoaformulario={form.idpessoaformulario}
                                pessoaformulario={form.pessoaformulario}
                            />
                        </div>
                    )}

                    {form.idtarefa && tabValue === 3 && (
                        <div className="p-24">
                            <TextField
                                className="mt-16"
                                label="Observações"
                                id="observacao"
                                name="observacao"
                                value={form.observacao}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={10}
                                readOnly={readOnly || form.conclusao !== null}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    )}
                    {form.idtarefaprocesso && tabValue === 4 && (
                        <div className="p-16">
                            <AppBar position="static">
                                <Tabs
                                    value={tabValueStatus}
                                    onChange={this.handleChangeTabStatus}
                                    variant="fullWidth"
                                >
                                    <Tab label="Tarefa" className="min-w-0" />
                                    <Tab label="Processo" className="min-w-0" />
                                </Tabs>
                            </AppBar>
                            {/*tabValueStatus === 0 &&
                                <TarefaStatusApp
                                    xappRouteParams={xappRouteParams}
                                    idtarefa={form.idtarefa}
                                />*/
                            }
                            {/*tabValueStatus === 1 &&
                                <TarefaProcessoStatusApp
                                    xappRouteParams={xappRouteParams}
                                    idtarefaprocesso={form.idtarefaprocesso}
                                />*/
                            }
                        </div>
                    )}
                    {form.idtarefaprocesso && tabValue === 5 && (
                        <EmpresaTarefaApp
                            xappRouteParams={xappRouteParams}
                            idparent={form.idtarefaprocesso}
                            tipo={2}
                        />
                    )}

                </DialogContent>
                {(_.isUndefined(form.conclusao) || _.isNull(form.conclusao) || [666, 999].includes(form.passofluxo)) &&
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions className="gap-6">
                                {((_.isUndefined(form.conclusao) || _.isNull(form.conclusao)) && form.idfluxo !== null) &&
                                    <GerenciadorProcessoApp
                                        Tarefa={form}
                                        passofluxo={form.passofluxo}
                                        xappRouteParams={xappRouteParams}
                                        getNext={form.passofluxo === 1 ? this.getNextStep : this.onClose}
                                        close={this.onClose}
                                        canBeSubmitted={this.canBeSubmitted}
                                        parametros={parametros}
                                    />
                                }
                                {[666, 999].includes(form.passofluxo) &&
                                    <React.Fragment>
                                        <XAPPButton
                                            type="Button"
                                            className="mr-12"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                Promise.all([
                                                    this.props.saveTarefa(form, xappRouteParams)
                                                ]).then(() => this.onClose());
                                            }}
                                            iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                            icon={"return"}
                                            label={md.mobile() === null && md.tablet() === null ? "RETORNAR" : ""}
                                        />
                                    </React.Fragment>
                                }
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                }
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTarefa: Actions.getTarefa,
        saveTarefa: Actions.saveTarefa,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ MinhasTarefas, auth }) {
    return {
        user: auth.user.data,
        formDialog: MinhasTarefas.MinhasTarefasReducer.formDialog,
        TagsTarefa: MinhasTarefas.TagFuncionalidadeReducer["agendamento"],
    };
}


export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MinhasTarefasDialog));
